import * as _ from "lodash";
import { deleteOrNop, getSafe, merge, setSafe, } from "../../../util/storeHelper";
import * as actions from "../actions/settings";
/**
 * reducer for changes to the window state
 */
export const settingsReducer = {
    reducers: {
        [actions.addDiscoveredGame]: (state, payload) => {
            // don't replace previously discovered games as the settings
            // there may also be user configuration
            const gamePath = ["discovered", payload.id];
            let result = payload.result;
            // If the path was manually set by the user, don't let auto-discovery overwrite it
            if (getSafe(state, [...gamePath, "pathSetManually"], false) &&
                !result.pathSetManually) {
                const { path: _path, ...rest } = result;
                result = rest;
            }
            const res = merge(state, gamePath, result);
            const merged = getSafe(res, gamePath, undefined);
            if (merged.executable === undefined) {
                // work around a problem where a value of undefined will be picked up as a
                // difference to the value not being set at all which triggered a change to be detected
                // every startup
                delete merged.executable;
            }
            if (result.path !== undefined && result.store === undefined) {
                // new path set but no store? fall back to default
                setSafe(res, [...gamePath, "store"], undefined);
            }
            // avoid triggering unnecessary events
            if (_.isEqual(getSafe(res, gamePath, undefined), getSafe(state, gamePath, undefined))) {
                return state;
            }
            else {
                return res;
            }
        },
        [actions.clearDiscoveredGame]: (state, payload) => {
            const { id } = payload;
            // if the path was set manually, reset that as well
            state = deleteOrNop(state, ["discovered", id, "pathSetManually"]);
            return deleteOrNop(state, ["discovered", id, "path"]);
        },
        [actions.setGamePath]: (state, payload) => {
            const input = {
                path: payload.gamePath,
                pathSetManually: payload.gamePath !== undefined,
                store: payload.store,
                // always include executable so that switching stores clears a stale
                // custom executable (e.g. gamepass.exe -> default game.exe)
                executable: payload.exePath,
            };
            const gamePath = ["discovered", payload.gameId];
            const res = merge(state, gamePath, input);
            const merged = getSafe(res, gamePath, undefined);
            if (merged.executable === undefined) {
                delete merged.executable;
            }
            return res;
        },
        [actions.addDiscoveredTool]: (state, payload) => {
            if (state.discovered[payload.gameId] === undefined) {
                return state;
            }
            const toolPath = ["discovered", payload.gameId, "tools", payload.toolId];
            // executable is a function. this shouldn't have been included in the first place but it's
            // easier to fix here
            // delete payload.result.executable;
            const old = _.omit(getSafe(state, toolPath, {}), [
                "timestamp",
            ]);
            if (!payload.manual) {
                if (_.isEqual(old, payload.result)) {
                    return state;
                }
            }
            return setSafe(state, toolPath, {
                ...payload.result,
                hidden: payload.hidden || old.hidden,
                timestamp: Date.now(),
            });
        },
        [actions.setToolVisible]: (state, payload) => 
        // custom added tools can be deleted so we do that instead of hiding them
        !payload.visible &&
            getSafe(state, ["discovered", payload.gameId, "tools", payload.toolId, "custom"], false)
            ? deleteOrNop(state, [
                "discovered",
                payload.gameId,
                "tools",
                payload.toolId,
            ])
            : setSafe(state, ["discovered", payload.gameId, "tools", payload.toolId, "hidden"], !payload.visible),
        [actions.setGameParameters]: (state, payload) => state.discovered[payload.gameId] === undefined
            ? state
            : merge(state, ["discovered", payload.gameId], payload.parameters),
        [actions.setGameHidden]: (state, payload) => setSafe(state, ["discovered", payload.gameId, "hidden"], payload.hidden),
        [actions.setGameSearchPaths]: (state, payload) => setSafe(state, ["searchPaths"], payload),
        [actions.setPickerLayout]: (state, payload) => setSafe(state, ["pickerLayout"], payload.layout),
        [actions.setSortManaged]: (state, payload) => setSafe(state, ["sortManaged"], payload),
        [actions.setSortUnmanaged]: (state, payload) => setSafe(state, ["sortUnmanaged"], payload),
    },
    defaults: {
        discovered: {},
        searchPaths: [],
        pickerLayout: "small",
        sortManaged: "alphabetical",
        sortUnmanaged: "alphabetical",
    },
};
